import { render } from "./app-vehicle-group-card.vue?vue&type=template&id=23d78166&scoped=true&ts=true"
import script from "./app-vehicle-group-card.vue?vue&type=script&lang=ts"
export * from "./app-vehicle-group-card.vue?vue&type=script&lang=ts"

import "./app-vehicle-group-card.vue?vue&type=style&index=0&id=23d78166&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23d78166"]])

export default __exports__